export const skills = [
  {
    category: 'Sistemas Operacionais',
    items: [
      'Windows',
      'Ubuntu',
      'Debian',
      'Kali Linux',
      'macOS',
      'Android'
    ],
  },
  {
    category: 'Linguagens de Programação',
    items: [
      'Uniface',
      'C',
      'C++',
      'C#',
      'Python',
      'Java',
      'JavaScript',
      'TypeScript',
      'HTML',
      'CSS',
      'Lua',
      'Arduino'
    ],
  },
  {
    category: 'Frameworks e Bibliotecas',
    items: [
      'React',
      'Next.js',
      'Node.js',
      'Spring',
      'TensorFlow',
      'PyTorch'
    ],
  },
  {
    category: 'Banco de Dados',
    items: [
      'PostgreSQL',
      'MySQL',
      'MongoDB',
      'H2',
      'PL/SQL'
    ],
  },
  {
    category: 'Dev Tools',
    items: [
      'Git',
      'Docker',
      'Vite',
      'DBeaver',
      'Draw.io'
    ],
  },
  {
    category: 'Game Development',
    items: [
      'Unity',
      'Godot',
      'Game Maker'
    ],
  },
  {
    category: 'Design e Prototipação',
    items: [
      'Figma',
      'Adobe XD',
      'Adobe Photoshop',
      'Canva',
      'Balsamiq'
    ],
  },
  {
    category: 'Produtividade e Colaboração',
    items: [
      'Jira',
      'Confluence'
    ],
  },
  {
    category: 'IA e Ferramentas Inteligentes',
    items: [
      'ChatGPT',
      'Claude',
      'Claude Code',
      'GitHub Copilot',
      'Sora'
    ],
  },
  {
    category: 'Documentação Técnica',
    items: [
      'LaTeX',
      'Sphinx',
      'MKDocs',
    ],
  }, 
];